/**
 * Function that processes a set of "redux-form" validators and returns a set of converted validation-function to "react-hooks-form".
 *
 * The function takes an input `validator`, which can either be an array of validation functions
 * or a single validation function. It returns a validation function that checks a given value
 * against the provided validators:
 * - If `validators` is an array, each function in the array will be called in sequence with the given value
 *   until one of the validators returns a non-falsy value, which will be returned immediately.
 *   If all validators return falsy values, the function returns `true`.
 * - If `validators` is a single function, the value is passed to the function, and it returns the
 *   function's result or `true` if the result is falsy.
 * - If no `validators` are provided, the function returns `undefined`.
 *
 * @param validators - An array of validation functions or a single validation function.
 * @param t - if not undefined then equal to translation hook
 * @returns A validation function or `undefined` if no validators are provided.
 */
export const rhfValidateFn = (validators: Array<Function> | Function, t?) => validators
  ? (value: unknown) => {
    if (Array.isArray(validators)) {
      for (const v of validators) {
        const res = v(value);
        if (res) {
          return t ? t(res) : res;
        }
      }

      return true;
    } else if (typeof validators === 'function') {
      const res = validators(value);
      if (res) {
        return t ? t(res) : res;
      }

      return true;
    }

    return true;
  }
  : undefined;
